import React, { useEffect, useState } from "react"
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { enumUtil } from "../../../../utils/Enum"
import NotificationHandler from "../../../../utils/NotificationHandler"
import FormValidator from "../../../../utils/FormValidator"
import isNull from "../../../../utils/NullChecking"
import { GetZipCode, ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import Loader from "../../../shared/Loader/Loader"
import { MenuItem, Select } from "@mui/material"
import { useDispatch } from "react-redux"
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Modal from 'react-bootstrap/Modal';
import handleNumericCheck from "../../../../utils/HandleNumericKeys"
import NpiRegistry from "../../../General/NpiRegistry"
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import States from "../../../../utils/Constants"
import { useSelector } from 'react-redux';
import ReactInputMask from "react-input-mask";
import Audit from "../../../General/Audit"
import ModalHeader from "../../Shared/ModalHeader"
import ModalFooter from "../../Shared/ModalFooter";
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import SuperSearch from "../../../shared/SuperSearch/SuperSearch"
import FormatPhoneNumber from "../../../../utils/FormatPhoneNumber";
import DropdownValueHandler from "../../../shared/SuperSearch/DropdownValueHandler";
import UpdateReduxDropDowns from "../../../shared/UpdateReduxDropDowns";
import { FindSecondChild } from "../../../../utils/FindMenuOption";
const AddNewBillingProvider = (props) => {

    let IsEditAllowed = FindSecondChild('Setup', 'Account', 'Billing Provider')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Account', 'Billing Provider')?.IsDeleted
    const API_URL = enumUtil.controller.General
    const { type, IsOpenBillingProvider, npiModal, onCloseProocedNpi, proceedHeader, onClose, onDeleteBillingProvider } = { ...props }
    const [del, setDel] = useState(false)
    const Reporting_Type = [
        { value: '', display: '' },
        { value: 'Person', display: 'Person' },
        { value: 'Organization', display: 'Organization' },
    ]


    let BillingProvider_Modal = {
        LocationID: null,
        ProviderID: null,
        InsuranceID: null,
        ReportingType: "",
        ProfileName: "",
        OrganizationName: "",
        FirstName: "",
        LastName: "",
        NPI: "",
        TaxonomyCode: "",
        LegacyID: "",
        ReportingLegacyID: "",
        DontReportNPI: "",
        AddressLine1: "",
        AddressLine2: "",
        City: "",
        State: "",
        ZipCode: "",
        PayToAddressLine1: "",
        PayToAddressLine2: "",
        PayToCity: "",
        PayToState: "",
        PayToZipCode: "",
        ContactPersonName: "",
        ContactPhoneNumber: "",
        EmailAddress: "",
        TaxID: "",
        MI: "",
        IsDefault: ""
    }

    let valModal = {}
    // validation modal 
    let ValidationModal = {
        FirstName: "",
        LastName: "",
        NPIVal: "",
        TaxIDLengthVal: "",
        ContactNumberLenghtVal: "",
        LocationID: "",
        ProviderID: "",
        InsuranceID: "",
        // TaxonomyCodeVal: "",
        EmailAddressVal: "",
        ZipCodeLengthVal: "",
        OrganizationOrLastNameVal: "",
        FirstNameVal: "",
        NPIRVal: "",
        TaxRVal: "",
        ZipCodeDigitVal: "",
        PaytoZipCodeLengthVal: ""
    }
    const dispatch = useDispatch()
    // const [practiceID, setPracticeID] = useState()
    const [mainBillingProviderModal, setmainBillingProviderModal] = useState(BillingProvider_Modal);
    const [BillingProviderSaveUpdateModal, setBillingProviderSaveUpdateModal] = useState({})
    const [practiceValidationModal, setPracticeValidationModal] = useState(ValidationModal)
    const [BillingProviderID, setBillingProviderID] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const [NpiRegistryNumber, setNpiRegistryNumber] = useState();
    const [isOpenRegistry, setIsOpenRegistry] = useState(false);
    const [statesValue, setStatesValue] = useState({ value: '', display: '' })
    const [PaytoStateValue, setPaytoStateValue] = useState({ value: '', display: '' })
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const [LocationValue, setLocationValue] = useState({ ID: '', Name: '' })
    const [ProviderValue, setProviderValue] = useState({ ID: '', Name: '' })
    const [InsuranceValue, setInsuranceValue] = useState({ ID: '', Name: '' })
    const [onBillingProviderSaved, setOnBillingProviderSaved] = useState(false)
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [errorOnPaste, seterrorOnPaste] = useState(false)
    // let [providerSaveUpdateModal, setProviderSaveUpdateModal] = useState({})
    const [is, setIs] = useState(false);
    // find practice Data by id 
    useEffect(() => {
        // setPracticeID(PracticeID)

        if (props.BillingProviderID != null) {
            setBillingProviderID(props.BillingProviderID)
            setDel(true)
        } else {
            if (!onBillingProviderSaved) {
                setBillingProviderID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (!isNull(BillingProviderID)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": BillingProviderID,
                "TableName": enumUtil.enumAPITableName.BillingProvider
            }).then((response) => {
                setIsLoading(false)
                setIs(true)
                response.State = DropdownValueHandler(States, response.State)
                response.PayToState = DropdownValueHandler(States, response.PayToState)
                response.LocationID = DropdownValueHandler(DropDowns?.Location, response.LocationID)
                response.ProviderID = DropdownValueHandler(DropDowns?.Provider, response.ProviderID)
                response.InsuranceID = DropdownValueHandler(DropDowns?.Insurance, response.InsuranceID)
                if (response.IsDefault === true) {
                    BillingProviderSaveUpdateModal.ProviderID = "-1";
                    BillingProviderSaveUpdateModal.LocationID = "-1";
                    BillingProviderSaveUpdateModal.InsuranceID = "-1";
                }
                if (!isNull(response.ContactPhoneNumber)) {
                    response.ContactPhoneNumber = FormatPhoneNumber(response.ContactPhoneNumber)
                }
                setmainBillingProviderModal(response)
            }).catch((error) => {
                setIsLoading(false)
                NotificationHandler(error.response.message, enumUtil.enumtoaster.error);
            })
        }
    }, [BillingProviderID])
    ///////Super Search////////
    const getTaxonomyCodeSelected = (selectedData, name, type) => {
        if (!isNull(selectedData)) {
            if (type === 'client') {
                if (name === 'State') {
                    // LocationSaveUpdateModal[name] = selectedData.selectedData
                    // setStatesValue(selectedData.display)
                }
            } else if (type === 'server') {
                if (name === 'TaxonomyCode') {
                    setmainBillingProviderModal({ ...mainBillingProviderModal, TaxonomyCode: selectedData.Code })
                    BillingProviderSaveUpdateModal['TaxonomyCode'] = selectedData.Code
                }
            }
        } else {
            if (name === "TaxonomyCode") {
                setmainBillingProviderModal({ ...mainBillingProviderModal, TaxonomyCode: '' })
                BillingProviderSaveUpdateModal['TaxonomyCode'] = ''
            }
        }
        return selectedData
    }

    // handle change for Practice 
    const handleBillingProviderChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainBillingProviderModal };
        let saveModal = { ...BillingProviderSaveUpdateModal }
        if (name === "ReportingLegacyID" || name === "DontReportNPI") {
            modal[name] = !modal[name]
        }
        else if (name === 'ZipCode') {
            GetZipCode(value)
                .then(data => {
                    setmainBillingProviderModal(prevState => ({ ...prevState, ...data?.main }));
                    setBillingProviderSaveUpdateModal(prevState => ({ ...prevState, ...data?.save }));
                })
                .catch(error => {
                });
            modal[name] = value;
        }
        else if (name === 'PayToZipCode') {
            GetZipCode(value)
                .then(data => {
                    modal.PayToState = data.main.State
                    modal.PayToCity = data.main.City
                    setmainBillingProviderModal(prevState => ({ ...prevState, PayToCity: data.main.City, PayToState: data.main.State }));
                    saveModal.PayToState = data.save.State
                    saveModal.PayToCity = data.save.City
                })
                .catch(error => {
                });
            modal[name] = value;
        } else if (name === 'ContactPhoneNumber') {
            const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        }
        else {
            modal[name] = value
        }

        setmainBillingProviderModal(modal)
        for (var property in BillingProvider_Modal) {
            if (name === property) {
                if (name === "ReportingLegacyID" || name === "DontReportNPI") {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }
            }
        }
        setBillingProviderSaveUpdateModal(saveModal)
    }
    const PracticeValidation = async () => {
        let PhoneNumber = "";
        if (!isNull(mainBillingProviderModal.ContactPhoneNumber)) {
            PhoneNumber = mainBillingProviderModal.ContactPhoneNumber.replace(/[()-\s]/g, "");
        }
        let ValidationModal = {

            ContactNumberLenghtVal: FormValidator(
                PhoneNumber,
                enumUtil.enumValidationType.Length,
                'Contact Number',
                10
            ),
            OrganizationOrLastNameVal: mainBillingProviderModal.ReportingType === "Organization"
                ? FormValidator(
                    mainBillingProviderModal.OrganizationName,
                    enumUtil.enumValidationType.Required,
                    'Organization Name'
                ) : null,
            FirstNameVal: mainBillingProviderModal.ReportingType === "Person"
                ? FormValidator(
                    mainBillingProviderModal.FirstName,
                    enumUtil.enumValidationType.Required,
                    'First Name'
                )
                : null,
            TaxIDLengthVal: FormValidator(
                mainBillingProviderModal.TaxID,
                enumUtil.enumValidationType.Length,
                'TaxID',
                9
            ),
            LocationID: mainBillingProviderModal.IsDefault === true ? null : FormValidator(
                mainBillingProviderModal.LocationID,
                enumUtil.enumValidationType.Required,
                'Location',
            ),
            ProviderID: mainBillingProviderModal.IsDefault === true ? null : FormValidator(
                mainBillingProviderModal.ProviderID,
                enumUtil.enumValidationType.Required,
                'Provider',
            ),
            InsuranceID: mainBillingProviderModal.IsDefault === true ? null : FormValidator(
                mainBillingProviderModal.InsuranceID,
                enumUtil.enumValidationType.Required,
                'Insurance',
            ),
            // TaxonomyCodeVal: FormValidator(
            //     mainBillingProviderModal.TaxonomyCode,
            //     enumUtil.enumValidationType.Required,
            //     'Taxonomy Code',
            // ),
            EmailAddressVal: FormValidator(
                mainBillingProviderModal.EmailAddress,
                enumUtil.enumValidationType.EmailAddress,
                'Email Address'
            ),
            NPIVal: FormValidator(
                mainBillingProviderModal.NPI,
                enumUtil.enumValidationType.Length,
                'NPI',
                10
            ),
            ZipCodeLengthVal: FormValidator(
                mainBillingProviderModal.ZipCode,
                enumUtil.enumValidationType.Length,
                'Zip Code',
                5, 9
            ),
            ProfileNameVal: FormValidator(
                mainBillingProviderModal.ProfileName,
                enumUtil.enumValidationType.Required,
                'Profile Name',
            ),
            NPIRVal: FormValidator(
                mainBillingProviderModal.NPI,
                enumUtil.enumValidationType.Required,
                'NPI',
            ),
            TaxRVal: FormValidator(
                mainBillingProviderModal.TaxID,
                enumUtil.enumValidationType.Required,
                'Tax ID',
            ),
            ZipCodeDigitVal: FormValidator(
                mainBillingProviderModal.ZipCode,
                enumUtil.enumValidationType.Digit,
                'Zip Code',
            ),
            PaytoZipCodeLengthVal: FormValidator(
                mainBillingProviderModal.ZipCode,
                enumUtil.enumValidationType.Length,
                'Zip Code',
                5, 9
            ),

        }
        await setPracticeValidationModal(ValidationModal)
        valModal = ValidationModal
    }

    // save practice button click 
    const handleSaveBillingProvider = async () => {
        await PracticeValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            // BillingProviderSaveUpdateModal['PracticeID'] = practiceID;
            if (!isNull(BillingProviderSaveUpdateModal.ContactPhoneNumber)) {
                BillingProviderSaveUpdateModal['ContactPhoneNumber'] = BillingProviderSaveUpdateModal.ContactPhoneNumber.replace(/[()-\s]/g, "");
                BillingProviderSaveUpdateModal.ContactPhoneNumber = BillingProviderSaveUpdateModal.ContactPhoneNumber.slice(0, 10);
            }
            setBillingProviderSaveUpdateModal(BillingProviderSaveUpdateModal)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.BillingProvider,
                ID: BillingProviderID,
                data: { ...BillingProviderSaveUpdateModal },
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        // UpdateReduxDropDowns(BillingProviderID, DropDowns.Provider, response.id, mainBillingProviderModal.LastName + ' , ' + mainBillingProviderModal.FirstName)
                        // UpdateReduxDropDowns(BillingProviderID, DropDowns.RefProvider, response.id, mainBillingProviderModal.LastName + ' , ' + mainBillingProviderModal.FirstName)
                        UpdateReduxDropDowns(BillingProviderID, DropDowns.BillingProvider, response.id, mainBillingProviderModal.ProfileName)
                        // if (BillingProviderID === 0) {
                        //     let obj = { value: response.id - "", display: mainBillingProviderModal.LastName + ', ' + mainBillingProviderModal.FirstName }
                        //     DropDowns.Provider.push(obj)
                        //     DropDowns.RefProvider.push(obj)
                        //     DropDowns.BillingProvider.push(obj)
                        // }
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        setBillingProviderID(response.id)
                        setOnBillingProviderSaved(true)
                        onDeleteBillingProvider()
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.message, enumUtil.enumtoaster.error)
                })
        }
    }

    const handleNpiRegistry = () => {
        if (mainBillingProviderModal.NPI != undefined) {
            setNpiRegistryNumber(mainBillingProviderModal.NPI)
        }
        setIsOpenRegistry(true);
        setIsLoading(false);
        onCloseProocedNpi();
    }
    const CloseRegistry = (data) => {
        console.log(data);
        setIs(true)
        mainBillingProviderModal.FirstName = !isNull(data.FirstName) ? data.FirstName : mainBillingProviderModal.FirstName
        mainBillingProviderModal.LastName = !isNull(data.LastName) ? data.LastName : mainBillingProviderModal.LastName
        mainBillingProviderModal.ProfileName = data.ProfileName
        mainBillingProviderModal.OrganizationName = data.NPIType === 'NPI-1' ? data.LastName : data.OrganizationName
        // mainBillingProviderModal.ContactPersonName = data.ContactPersonName
        mainBillingProviderModal.AddressLine1 = data.AddressLine1
        mainBillingProviderModal.AddressLine2 = data.AddressLine2
        mainBillingProviderModal.City = data.City
        mainBillingProviderModal.State = DropdownValueHandler(States, data.State)
        // mainBillingProviderModal.State = data.State
        mainBillingProviderModal.ZipCode = data.ZipCode
        const formattedcontactNumber = FormatPhoneNumber(data.ContactPhoneNumber)
        mainBillingProviderModal.ContactPhoneNumber = formattedcontactNumber
        mainBillingProviderModal.PayToAddressLine1 = data.PayToAddressLine1
        mainBillingProviderModal.PayToAddressLine2 = data.PayToAddressLine2
        mainBillingProviderModal.PayToCity = data.PayToCity
        mainBillingProviderModal.PayToState = DropdownValueHandler(States, data.PayToState)
        // mainBillingProviderModal.PayToState = data.PayToState
        mainBillingProviderModal.PayToZipCode = data.PayToZipCode
        mainBillingProviderModal.NPI = data.NPI
        mainBillingProviderModal.TaxonomyCode = data.TaxonomyCode
        mainBillingProviderModal.ContactPersonName = !isNull(data.ContactPersonName) ? data.ContactPersonName : mainBillingProviderModal.ContactPersonName
        //SaveUpdateModal
        BillingProviderSaveUpdateModal.FirstName = !isNull(data.FirstName) ? data.FirstName : mainBillingProviderModal.FirstName
        BillingProviderSaveUpdateModal.LastName = !isNull(data.LastName) ? data.LastName : mainBillingProviderModal.LastName
        BillingProviderSaveUpdateModal.ProfileName = data.ProfileName
        BillingProviderSaveUpdateModal.AddressLine1 = data.AddressLine1
        BillingProviderSaveUpdateModal.AddressLine2 = data.AddressLine2
        BillingProviderSaveUpdateModal.City = data.City
        BillingProviderSaveUpdateModal.State = data.State
        BillingProviderSaveUpdateModal.ZipCode = data.ZipCode
        BillingProviderSaveUpdateModal.ContactPhoneNumber = formattedcontactNumber
        BillingProviderSaveUpdateModal.PayToAddressLine1 = data.PayToAddressLine1
        BillingProviderSaveUpdateModal.PayToAddressLine2 = data.PayToAddressLine2
        BillingProviderSaveUpdateModal.PayToCity = data.PayToCity
        BillingProviderSaveUpdateModal.PayToState = data.PayToState
        BillingProviderSaveUpdateModal.PayToZipCode = data.PayToZipCode
        BillingProviderSaveUpdateModal.NPI = data.NPI
        BillingProviderSaveUpdateModal.TaxonomyCode = data.TaxonomyCode
        BillingProviderSaveUpdateModal.ContactPersonName = !isNull(data.ContactPersonName) ? data.ContactPersonName : BillingProviderSaveUpdateModal.ContactPersonName
        setIsOpenRegistry(false)
    }


    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    const onCloseNpi = () => {
        setIsOpenRegistry(false)
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent'} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.BillingProvider} ID={BillingProviderID} onClose={onDeleteBillingProvider} dropDown={DropDowns?.BillingProvider} />
    }
    let PopupScreen = "";
    if (isOpenRegistry) {
        PopupScreen = <NpiRegistry isOpenRegistry={isOpenRegistry} NpiNumber={NpiRegistryNumber} onClosee={CloseRegistry} onCloseNpi={onCloseNpi} ClassName='npi-panel npi-open npi_detail_popup' />
    }
    const SetBillProviderName = () => {
        if (mainBillingProviderModal.ProfileName != null && mainBillingProviderModal.ProfileName != "") {
            return (
                <p className="heading sm">{mainBillingProviderModal.ProfileName}</p>
            )
        } else {
            return (
                <p className="heading sm">Add New Bill. Provider</p>
            )
        }
    }
    const handleDropDownChange = (value, type) => {
        if (type === 'State') {
            setStatesValue(value)
            BillingProviderSaveUpdateModal['State'] = value.value
        } else if (type === 'PayToState') {
            setPaytoStateValue(value)
            BillingProviderSaveUpdateModal['PayToState'] = value.value
        }
        else if (type === 'LocationID') {
            setLocationValue(value)
            BillingProviderSaveUpdateModal['LocationID'] = value.ID + ""
        }
        else if (type === 'ProviderID') {
            setProviderValue(value)
            BillingProviderSaveUpdateModal['ProviderID'] = value.ID + ""

        }
        else if (type === 'InsuranceID') {
            setInsuranceValue(value)
            BillingProviderSaveUpdateModal['InsuranceID'] = value.ID + ""
        }
    }
    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={BillingProviderID + ""} TableName={enumUtil.enumAPITableName.BillingProvider} />
    }
    const handleSelectedData = (selectedData, name, type) => {
        let modal = { ...mainBillingProviderModal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'State') {
                modal[name] = selectedData.display
                BillingProviderSaveUpdateModal[name] = selectedData.value;
            }

            else if (name === 'PayToState') {
                modal[name] = selectedData.display
                BillingProviderSaveUpdateModal[name] = selectedData.value;
            }
            else if (name === 'LocationID') {
                modal[name] = selectedData.display
                BillingProviderSaveUpdateModal[name] = selectedData.value + "";
            }
            else if (name === 'ProviderID') {
                modal[name] = selectedData.display
                BillingProviderSaveUpdateModal[name] = selectedData.value + "";
            }
            else if (name === 'InsuranceID') {
                modal[name] = selectedData.display
                BillingProviderSaveUpdateModal[name] = selectedData.value + "";
            }
            else if (name === 'ReportingType') {
                modal[name] = selectedData.display
                BillingProviderSaveUpdateModal[name] = selectedData.value + "";
            }


        } else if (type === 'server' && !isNull(selectedData)) {
            // if (name === 'POSCode') {
            //     LocationSaveUpdateModal[name] = selectedData.ID
            //     setPOS(selectedData.ID)


        } else {

            modal[name] = ''
            BillingProviderSaveUpdateModal[name] = ''
        }
        setmainBillingProviderModal(modal)

        return selectedData
    }
    const AddNewBillingModalBody = () => {
        return (
            <div className="row g-0 h-100">
                <div className="col-md-4 br-clr br-right-1">
                    <div className="pe-3">
                        <div className="form-group input">
                            <label htmlFor="">Profile Name<span className='req'>*</span></label>
                            <div className={practiceValidationModal.ProfileNameVal ? 'input error' : 'form-group input'}>
                                <input type="text"
                                    className='form-control'
                                    name="ProfileName"
                                    id="ProfileName"
                                    autoComplete="off"
                                    value={mainBillingProviderModal.ProfileName}
                                    onChange={handleBillingProviderChange}
                                    readOnly={mainBillingProviderModal.IsDefault}
                                />
                                {practiceValidationModal.ProfileNameVal}
                            </div>
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="">Location<span className='req'>*</span></label>
                            <SuperSearchList
                                className='form-control'
                                type="client"
                                id='LocationID'
                                autoComplete="off"
                                name='LocationID'
                                searchValue={mainBillingProviderModal.IsDefault ? "All Location" : mainBillingProviderModal.LocationID}
                                data={DropDowns.Location}
                                onChange={handleBillingProviderChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                isReadOnly={mainBillingProviderModal.IsDefault}
                                inputError={practiceValidationModal.LocationID}
                            />
                            {practiceValidationModal.LocationID}
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="">Provider<span className='req'>*</span></label>
                            <SuperSearchList
                                type="client"
                                id='ProviderID'
                                name='ProviderID'
                                autoComplete="off"
                                searchValue={mainBillingProviderModal.IsDefault ? "All Provider" : mainBillingProviderModal.ProviderID}
                                data={DropDowns.Provider}
                                onChange={handleBillingProviderChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                isReadOnly={mainBillingProviderModal.IsDefault}
                                inputError={practiceValidationModal.ProviderID}
                            />
                            {practiceValidationModal.ProviderID}
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="">Insurance<span className='req'>*</span></label>
                            <SuperSearchList
                                type="client"
                                id='InsuranceID'
                                name='InsuranceID'
                                autoComplete="off"
                                searchValue={mainBillingProviderModal.IsDefault ? "All Insurance" : mainBillingProviderModal.InsuranceID}
                                data={[
                                    { display: '', value: '' },
                                    ...(DropDowns?.Insurance || [])
                                ]}

                                onChange={handleBillingProviderChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                                isReadOnly={mainBillingProviderModal.IsDefault}
                                inputError={practiceValidationModal.InsuranceID}
                            />
                            {practiceValidationModal.InsuranceID}
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="">Reporting Type</label>
                            <SuperSearchList
                                type="client"
                                id='ReportingType'
                                name='ReportingType'
                                autoComplete="off"
                                searchValue={mainBillingProviderModal.ReportingType}
                                data={Reporting_Type}
                                onChange={handleBillingProviderChange}
                                getSelectedData={handleSelectedData}
                                is={is}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                            // filterWith="startsWith"
                            // tableHeight="200px"
                            // tableWidth="100%"
                            />
                        </div>
                        <div className="form-group input">
                            <label htmlFor="">Organization or Last Name</label>
                            <div className={practiceValidationModal.OrganizationOrLastNameVal ? 'input error' : 'input'}>
                                <input type="text"
                                    className='form-control'
                                    name="OrganizationName"
                                    id="OrganizationName"
                                    autoComplete="off"
                                    value={mainBillingProviderModal.OrganizationName}
                                    onChange={handleBillingProviderChange} />
                                {practiceValidationModal.OrganizationOrLastNameVal}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group input">
                                    <label htmlFor="">First Name</label>
                                    <div className={practiceValidationModal.FirstNameVal ? 'input error' : 'input'}>
                                        <input type="text"
                                            className='form-control'
                                            name="FirstName"
                                            id="FirstName"
                                            autoComplete="off"
                                            value={mainBillingProviderModal.FirstName}
                                            onChange={handleBillingProviderChange} />
                                        {practiceValidationModal.FirstNameVal}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className='form-group input'>
                                    <label htmlFor="">Middle Initial</label>
                                    <input type="text"
                                        className='form-control'
                                        name="MI"
                                        id="MI"
                                        autoComplete="off"
                                        value={mainBillingProviderModal.MI}
                                        onChange={handleBillingProviderChange} />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="col-md-8">
                    <div className="app-accordian">
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                id="Billingprovider-header"
                                aria-controls="Billingprovider-content"

                            >
                                <p className="heading">Legal ID</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row row-half row-gap-15 row-half'>

                                    <div className="col-md-3">
                                        <div className="form-group input">
                                            <label >NPI<span className='req'>*</span></label>
                                            <div className={practiceValidationModal.NPIVal || practiceValidationModal.NPIRVal ? 'input error' : 'input'}>
                                                <div className='field-icon'>
                                                    <input type="text"
                                                        className='form-control'
                                                        name="NPI"
                                                        id="NPI"
                                                        autoComplete="off"
                                                        value={mainBillingProviderModal.NPI}
                                                        onChange={handleBillingProviderChange}
                                                        maxLength={10}
                                                        onKeyPress={(event) => handleNumericCheck(event)} />
                                                    <div className='last'>
                                                        <div className="app_tooltip left" onClick={handleNpiRegistry}>
                                                            <div className='NPI-R-circle'>R</div>
                                                            <p class="tool_tip xsm_text text-light">NPI Registry</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                {practiceValidationModal.NPIVal || practiceValidationModal.NPIRVal}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group input">
                                            <label >Tax ID<span className='req'>*</span></label>
                                            <div className={practiceValidationModal.TaxIDLengthVal || practiceValidationModal.TaxRVal ? 'form-group input error' : 'form-group input'}>
                                                <input type="text"
                                                    className='form-control'
                                                    name="TaxID"
                                                    id="TaxID"
                                                    autoComplete="off"
                                                    maxLength={10}
                                                    value={mainBillingProviderModal.TaxID}
                                                    onChange={handleBillingProviderChange} />
                                                {practiceValidationModal.TaxIDLengthVal || practiceValidationModal.TaxRVal}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label >Taxonomy Code</label>
                                            <div style={{ width: '110px', position: 'relative' }}>
                                                <SuperSearch
                                                    ApiLink={API_URL + "/InstantSearch"}
                                                    method="post"
                                                    postBody={{
                                                        "TableName": enumUtil.enumAPITableName.Taxonomy,
                                                        "SearchParam": mainBillingProviderModal.TaxonomyCode,
                                                    }}
                                                    tableHeight={400}
                                                    tableWidth="400px"
                                                    id={'TaxonomyCode'}
                                                    getSelectedData={(value) => getTaxonomyCodeSelected(value, "TaxonomyCode", "server")}
                                                    onChange={(e) => setmainBillingProviderModal({ ...mainBillingProviderModal, TaxonomyCode: e.target.value })}
                                                    searchValue={mainBillingProviderModal.TaxonomyCode}
                                                    tableData={[
                                                        // { columName: 'ID', bindingValue: 'TaxonomyID', },
                                                        { columName: 'Code', bindingValue: 'Code', },
                                                        { columName: 'Medicare Speciality Code', bindingValue: 'MedicareSpecialityCode', },
                                                    ]}
                                                    name="TaxonomyCode"
                                                    disabled={false}
                                                    sup_btn='sup_btn-Inp'
                                                    sup_inp='superSearchVisitInp'
                                                />
                                                {/* {practiceValidationModal.TaxIDLengthVal} */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label >Legacy ID</label>
                                            <input type="text"
                                                className='form-control'
                                                name="LegacyID"
                                                id="LegacyID"
                                                autoComplete="off"
                                                value={mainBillingProviderModal.LegacyID}
                                                onChange={handleBillingProviderChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div class="form-check custom_check_box">
                                            <input class="form-check-input p-0"
                                                type="checkbox"
                                                id="ReportingLegacyID"
                                                name="ReportingLegacyID"
                                                autoComplete="off"
                                                checked={mainBillingProviderModal.ReportingLegacyID}
                                                onChange={handleBillingProviderChange} />
                                            <label class="form-check-label" for="inlineCheckbox1">Reporting Legacy ID</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div class="form-check custom_check_box">
                                            <input class="form-check-input p-0"
                                                type="checkbox"
                                                id="DontReportNPI"
                                                name="DontReportNPI"
                                                autoComplete="off"
                                                checked={mainBillingProviderModal.DontReportNPI}
                                                onChange={handleBillingProviderChange} />
                                            <label class="form-check-label" for="inlineCheckbox2">Don’t Report NPI</label>
                                        </div>
                                    </div>

                                </div>

                            </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="Billingprovider2-content"
                                id="Billingprovider2-header"
                            >
                                <p className="heading">Address Information</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row row-half row-gap-15 row-half align-items-center'>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label >Address Line 1</label>
                                            <input type="text"
                                                className='form-control'
                                                name="AddressLine1"
                                                id="AddressLine1"
                                                autoComplete="off"
                                                value={mainBillingProviderModal.AddressLine1}
                                                onChange={handleBillingProviderChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label >Address Line 2</label>
                                            <input type="text"
                                                className='form-control'
                                                name="AddressLine2"
                                                id="AddressLine2"
                                                autoComplete="off"
                                                value={mainBillingProviderModal.AddressLine2}
                                                onChange={handleBillingProviderChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row row-gap-15 row-half mt-3">
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label >City</label>
                                            <input type="text"
                                                className='form-control'
                                                name="City"
                                                id="City"
                                                autoComplete="off"
                                                value={mainBillingProviderModal.City}
                                                onChange={handleBillingProviderChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label >State</label>
                                            <SuperSearchList
                                                type="client"
                                                id='State'
                                                name='State'
                                                searchValue={mainBillingProviderModal.State}
                                                data={States}
                                                onChange={handleBillingProviderChange}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            // filterWith="startsWith"
                                            // tableHeight="200px"
                                            // tableWidth="100%"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group input">
                                            <label >Zip Code</label>
                                            <div className={practiceValidationModal.ZipCodeDigitVal || practiceValidationModal.ZipCodeLengthVal ? 'input error' : 'input'}>
                                                <input type="text"
                                                    className='form-control'
                                                    name="ZipCode"
                                                    id="ZipCode"
                                                    autoComplete="off"
                                                    maxLength={9}
                                                    value={mainBillingProviderModal.ZipCode}
                                                    onChange={handleBillingProviderChange}
                                                />
                                                {practiceValidationModal.ZipCodeDigitVal || practiceValidationModal.ZipCodeLengthVal}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                id="Billingprovider2-content"
                                aria-controls="Billingprovider2-content"
                            >
                                <p className="heading">Pay to Address Information</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row row-half row-gap-15 row-half'>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label >Pay to Address Line 1</label>
                                            <input type="text"
                                                className='form-control'
                                                name="PayToAddressLine1"
                                                id="PayToAddressLine1"
                                                autoComplete="off"
                                                value={mainBillingProviderModal.PayToAddressLine1}
                                                onChange={handleBillingProviderChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label >Pay to Address Line 2</label>
                                            <input type="text"
                                                className='form-control'
                                                name="PayToAddressLine2"
                                                id="PayToAddressLine2"
                                                autoComplete="off"
                                                value={mainBillingProviderModal.PayToAddressLine2}
                                                onChange={handleBillingProviderChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label >Pay to City</label>
                                            <input type="text"
                                                className='form-control'
                                                name="PayToCity"
                                                id="PayToCity"
                                                autoComplete="off"
                                                value={mainBillingProviderModal.PayToCity}
                                                onChange={handleBillingProviderChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label >Pay to State</label>
                                            <SuperSearchList
                                                type="client"
                                                id='PayToState'
                                                name='PayToState'
                                                searchValue={mainBillingProviderModal.PayToState}
                                                data={States}
                                                onChange={handleBillingProviderChange}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            // filterWith="startsWith"
                                            // tableHeight="200px"
                                            // tableWidth="100%"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='form-group input'>
                                            <label >Pay to Zip</label>
                                            <div className={practiceValidationModal.ZipCodeDigitVal || practiceValidationModal.PaytoZipCodeLengthVal ? 'input error' : 'input'}>
                                                <input type="text"
                                                    className='form-control'
                                                    name="PayToZipCode"
                                                    id="PayToZipCode"
                                                    autoComplete="off"
                                                    maxLength={9}
                                                    value={mainBillingProviderModal.PayToZipCode}
                                                    onChange={handleBillingProviderChange} />
                                                {practiceValidationModal.ZipCodeDigitVal || practiceValidationModal.PaytoZipCodeLengthVal}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        {/* <div className="col-md-6">
                                                    <div className='input'>
                                                        <label >MI</label>
                                                        <input type="text"
                                                            className='form-control'
                                                            name="MI"
                                                            id="MI"
                                                            value={mainBillingProviderModal.MI}
                                                            onChange={handleBillingProviderChange} />
                                                    </div>
                                                </div> */}


                        <Accordion>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="Billingprovider2-content"
                                id="Billingprovider2-header"
                            >
                                <p className="heading">Contact Information</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row row-half row-gap-15 row-half align-items-center'>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label>Contact Person Name</label>
                                            <input
                                                type="text"
                                                className='form-control'
                                                name="ContactPersonName"
                                                id="ContactPersonName"
                                                autoComplete="off"
                                                value={mainBillingProviderModal.ContactPersonName}
                                                onChange={handleBillingProviderChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group input">
                                            <label>Contact Number</label>
                                            <div className={practiceValidationModal.ContactNumberLenghtVal ? 'form-group input error' : 'form-group input'}>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    placeholder="(555) 555-5555"
                                                    name="ContactPhoneNumber"
                                                    id="ContactPhoneNumber"
                                                    autoComplete="off"
                                                    value={mainBillingProviderModal.ContactPhoneNumber}
                                                    onChange={handleBillingProviderChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                />
                                                {practiceValidationModal.ContactNumberLenghtVal}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group input">
                                            <label htmlFor="">Email Address</label>
                                            <div className={practiceValidationModal.EmailAddressVal ? 'form-group input error' : 'form-group input'}>
                                                <input
                                                    maxLength={50}
                                                    type="email"
                                                    className='form-control'
                                                    name="EmailAddress"
                                                    id="EmailAddress"
                                                    autoComplete="off"
                                                    value={mainBillingProviderModal.EmailAddress}
                                                    onChange={handleBillingProviderChange}
                                                />
                                                {practiceValidationModal.EmailAddressVal}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <React.Fragment>
            {type && type === "Wizard" ?
                <>
                    {BillingProviderID == 0 ?
                        <Modal show={npiModal} onHide={onCloseProocedNpi} backdrop="static" keyboard={false} dialogClassName="app-modal modal-lg proceed_npi_modal">
                            <Modal.Body>
                                {/* <SearchHeader masterListButton={proceedNPI} /> */}
                                <ModalHeader HeaderName={proceedHeader} DeletePopup={""} isClosed={onCloseProocedNpi} key={631} Name={'SwitchPractice'} />
                                <div className='container-fluid  br-clr'>
                                    <div className="row">
                                        <div className={practiceValidationModal.NPILengthVal ? 'form-group input error' : 'form-group input'}>
                                            <div className='field-icon'>
                                                <input type="text"
                                                    className='form-control'
                                                    name="NPI"
                                                    id="NPI"
                                                    autoComplete="off"
                                                    autoFocus={true}
                                                    maxLength={10}
                                                    value={mainBillingProviderModal.NPI}
                                                    onChange={handleBillingProviderChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                />
                                                {practiceValidationModal.NPILengthVal}
                                            </div>
                                        </div>
                                        <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                            <button class="btn btn-orange btn-xs no-width rounded mb-0 proceed_btn" onClick={handleNpiRegistry}>Proceed <i className="icon-arrow-right"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal> : null}
                    {DeleteConfirmation}
                    {AuditPopup}
                    {/* <div className='d-flex justify-content-between mb-3'>
                          {SetBillProviderName()}
                          <div className="row">
                              <button aria-describedby={Boolean(isOpenAudit) ? 'simple-popper' : undefined} type="button" className='btn-icon-transparent' onClick={handleAuditModal}>
                                  <span class="icon-menu-1"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span></span>
                              </button>
                              {DeletePopup}
                          </div>
                      </div> */}
                    {isLoading ? <Loader /> : null}
                    <div className="pb-15">
                        {AddNewBillingModalBody()}
                    </div>
                    <ModalFooter isSaved={onBillingProviderSaved ? onDeleteBillingProvider : onClose} handleSave={handleSaveBillingProvider} key={615} Name={'Billing Prov'} UpdatedDate={mainBillingProviderModal.UpdatedDate} UpdatedBy={mainBillingProviderModal.UpdatedBy} ID={BillingProviderID} IsEditAllowed={IsEditAllowed} />
                    {PopupScreen}
                </>
                :
                <>
                    {BillingProviderID == 0 ?
                        <Modal show={npiModal} onHide={onCloseProocedNpi} backdrop="static" keyboard={false} dialogClassName="app-modal modal-lg proceed_npi_modal">
                            <Modal.Body>
                                {/* <SearchHeader masterListButton={proceedNPI} /> */}
                                <ModalHeader HeaderName={proceedHeader} DeletePopup={""} isClosed={onCloseProocedNpi} key={631} Name={'SwitchPractice'} />
                                <div className='container-fluid  br-clr'>
                                    <div className="row">
                                        <div className={practiceValidationModal.NPILengthVal ? 'form-group input error' : 'form-group input'}>
                                            <div className='field-icon'>
                                                <input type="text"
                                                    className='form-control'
                                                    name="NPI"
                                                    id="NPI"
                                                    autoComplete="off"
                                                    autoFocus={true}
                                                    maxLength={10}
                                                    value={mainBillingProviderModal.NPI}
                                                    onChange={handleBillingProviderChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                />
                                                {practiceValidationModal.NPILengthVal}
                                            </div>
                                        </div>
                                        <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                            <button class="btn btn-orange btn-xs no-width rounded mb-0 proceed_btn" onClick={handleNpiRegistry}>Proceed <i className="icon-arrow-right"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal> : null}
                    {DeleteConfirmation}
                    <Modal show={IsOpenBillingProvider} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1">
                        {AuditPopup}
                        <Modal.Body>
                            {/* <div className='d-flex justify-content-between mb-3'>
                        {SetBillProviderName()}
                        <div className="row">
                            <button aria-describedby={Boolean(isOpenAudit) ? 'simple-popper' : undefined} type="button" className='btn-icon-transparent' onClick={handleAuditModal}>
                                <span class="icon-menu-1"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span></span>
                            </button>
                            {DeletePopup}
                        </div>
                    </div> */}
                            <ModalHeader HeaderName={SetBillProviderName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onBillingProviderSaved ? onDeleteBillingProvider : onClose} key={615} Name={'Billing Provider'} />
                            {isLoading ? <Loader /> : null}
                            {AddNewBillingModalBody()}
                            {PopupScreen}
                        </Modal.Body>
                        <ModalFooter isSaved={onBillingProviderSaved ? onDeleteBillingProvider : onClose} handleSave={handleSaveBillingProvider} key={615} Name={'Billing Prov'} UpdatedDate={mainBillingProviderModal.UpdatedDate} UpdatedBy={mainBillingProviderModal.UpdatedBy} ID={BillingProviderID} IsEditAllowed={IsEditAllowed} />
                    </Modal>
                </>
            }

        </React.Fragment>

    )
}
export default AddNewBillingProvider